import React, { useEffect, useMemo, useState } from "react";
import { cx } from "@jugl-web/utils";
import instagramShadowImage from "../CXSignupDialog/assets/instagram-shadow.png";
import instagramGhostImage from "../CXSignupDialog/assets/instagram-ghost.png";
import whatsappShadowImage from "../CXSignupDialog/assets/whatsapp-shadow.png";
import whatsappGhostImage from "../CXSignupDialog/assets/whatsapp-ghost.png";
import webShadowImage from "../CXSignupDialog/assets/web-shadow.png";
import webGhostImage from "../CXSignupDialog/assets/web-ghost.png";
import twilioShadowImage from "../CXSignupDialog/assets/twilio-shadow.png";
import twilioGhostImage from "../CXSignupDialog/assets/twilio-ghost.png";

export const CXImageCarousel: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const slides = useMemo(
    () => [
      { ghost: instagramGhostImage, shadow: instagramShadowImage },
      { ghost: whatsappGhostImage, shadow: whatsappShadowImage },
      { ghost: webGhostImage, shadow: webShadowImage },
      { ghost: twilioGhostImage, shadow: twilioShadowImage },
    ],
    []
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((c) => (c + 1) % slides.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="bg-dark relative mr-12 hidden h-full w-[476px] shrink-0 [@media(min-width:1170px)_and_(min-height:650px)]:block">
      {slides.map((slide, index) => (
        <div
          key={+index}
          className={cx(
            "pointer-events-none transition-opacity duration-700",
            index === currentIndex ? "opacity-100" : "opacity-0"
          )}
        >
          <img
            src={slide.shadow}
            className="absolute left-0 top-1/2 w-3/4 -translate-y-1/2"
            alt=""
          />
          <img
            src={slide.ghost}
            className="absolute left-0 top-1/2 w-[510px] -translate-y-1/2"
            alt=""
          />
        </div>
      ))}
    </div>
  );
};
